import { Injectable, signal, computed } from '@angular/core';
import { NotificationItem, NotificationService } from '../notification.service';

/** Placeholder until the backend exposes a notification contract. It never
 * falls back to mock data in API mode. */
@Injectable()
export class ApiNotificationService extends NotificationService {
  private readonly items = signal<readonly NotificationItem[]>([]);
  readonly notifications = this.items.asReadonly();
  readonly unreadCount = computed(() => 0);
  markAllRead(): void { /* No backend endpoint currently available. */ }
}
